import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("crmUser");
    return stored ? JSON.parse(stored) : null;
  });

  const login = (userData) => {
    localStorage.setItem("crmUser", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("crmUser");
    localStorage.removeItem("agentCompanySelected");
    localStorage.removeItem("agentCompany");
    localStorage.removeItem("agentId");
    setUser(null);
  };

    const updateUser = (updatedData) => {
    const newUser = { ...user, ...updatedData };
    localStorage.setItem("crmUser", JSON.stringify(newUser));
    setUser(newUser);
  };


  return (
    <AuthContext.Provider value={{ user, login, logout ,updateUser}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
